module.exports = __webpack_public_path__ + "img/mid-content.d053448f.svg";